export default {
  presenter: 'stehlik',
  title: 'Instalace linuxu na Orange Pi',
  subtitle: 'začátečníci',
  text: `
Rád bych úplným začátečníkům ukázal, jak do počítače velikosti dlaně (Orange Pi, Raspberry Pi)
nainstalovat a trošku nakonfigurovat operační systém známý z velkých stolních počítačů. Můžete
si pak nosit svou pracovní stanici v náprsní kapse :-)
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/stehlik-orange-pi.js